import type { Option } from "@inrev/core";
import { Banner, ClickableText, Text } from "../../primitives";

export interface RetryableLoadErrorProps {
	resource: string;
	onRetry: () => void;
	retrying?: boolean;
	testId?: string;
	trackingId?: string;
	/** Extra analytics attributes on the Retry control, such as the record it retries. */
	retryDataAttributes?: Option<Record<`data-${string}`, string>>;
	className?: string;
}

export const unableToLoadMessage = (resource: string, consequence?: string) =>
	consequence ? `Unable to load ${resource}, so ${consequence}.` : `Unable to load ${resource}.`;

export const RetryableLoadError = ({
	resource,
	onRetry,
	retrying = false,
	testId = "retryable-load-error",
	trackingId,
	retryDataAttributes,
	className,
}: RetryableLoadErrorProps) => (
	<Banner tone="default" data-testid={testId} trackingId={trackingId} className={className}>
		<Banner.Content className="text-center">
			<Text type="body" color="secondary">
				{unableToLoadMessage(resource)}{" "}
				<ClickableText
					type="body"
					color="link"
					onClick={onRetry}
					disabled={retrying}
					trackingId={trackingId && `${trackingId}-retry`}
					{...retryDataAttributes}
				>
					{retrying ? "Retrying…" : "Retry"}
				</ClickableText>
			</Text>
		</Banner.Content>
	</Banner>
);
